import { receiptResult } from './common'
import okeResponse from 'okeoke.standardresponse'

const printReceiptSerial = async (fiscalReceipt = null, printSlip, commandFunction = null, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt, deviceParams?.printer)
  if (comRes?.codes == null) {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
  for await (let code of comRes?.codes) {
    console.log('ptg serial code:', code)
    let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: code || '', params: deviceParams?.printer || {} } })
    if (!res?.data?.success) {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
    }
  }
  return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, comRes.paymentsTotal, null, null)
}

const printReceiptBT = async (fiscalReceipt = null, printSlip, commandFunction = null, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt, deviceParams?.printer)
  if (comRes?.codes == null) {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
  for await (let code of comRes?.codes) {
    console.log('ptg bt code:', code)
    let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: code || '', params: deviceParams?.printer || {} } })
    if (res?.data?.success) {
      return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, comRes.paymentsTotal, null, null)
    }
  }
  return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
}

const printReceiptQR = async (fiscalReceipt = null, printSlip, commandFunction = null, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt, { ...(deviceParams?.printer || {}), printByRegister: true })
  if (comRes?.codes) {
    for(let code of comRes?.codes) {
      console.log('ptg qr code:', code)
    }
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, comRes.paymentsTotal, null, null, comRes.codes)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
}

const payInSerial = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code === 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.unsupported" })
    }
    let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: comRes.code, params: deviceParams?.printer || {} } })
    return res?.data || okeResponse(false, 400, 'Unknown error.', null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.error" })
  }
}


const payInBT = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code === 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.unsupported" })
    }
    let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: comRes.code, params: deviceParams?.printer || {} } })
    return res?.data || okeResponse(false, 400, 'Unknown error.', null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.error" })
  }
}

const payInQR = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code == 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.unsupported" })
    }
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, amount, null, null, [comRes.code])
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payIn.commands.error" })
  }
}

const payOutSerial = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code === 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payOut.commands.unsupported" })
    }
    let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: comRes.code, params: deviceParams?.printer || {} } })
    return res?.data || okeResponse(false, 400, 'Unknown error.', null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payOut.commands.error" })
  }
}

const payOutBT = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code === 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payOut.commands.unsupported" })
    }
    let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: comRes.code, params: deviceParams?.printer || {} } })
    return res?.data || okeResponse(false, 400, 'Unknown error.', null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payOut.commands.error" })
  }
}

const payOutQR = async (reason, amount, agentType, commandFunction, deviceParams, sendMessageToWebView, info) => {
  let comRes = commandFunction(reason + 1, amount, agentType, info)
  if (comRes?.code) {
    if(comRes?.code === 'UNSUPPORTED') {
      return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.payOut.commands.unsupported" })
    }
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, amount, null, null, [comRes.code])
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
}

const openDaySerial = async (register, amount, commandFunction, deviceParams, sendMessageToWebView) => {
  let command = commandFunction(register, amount)
  let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: command?.code || '', params: deviceParams?.printer || {} } })
  return res?.data || okeResponse(false, 400, 'Unknown error.', null)
}

const openDayBT = async (register, amount, commandFunction, deviceParams, sendMessageToWebView) => {
  let command = commandFunction(register, amount)
  let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: command?.code || '', params: deviceParams?.printer || {} } })
  return res?.data || okeResponse(false, 400, 'Unknown error.', null)
}

const openDayQR = async (register, amount, commandFunction, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(register, amount)
  if (comRes?.code) {
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, amount, null, null, [comRes.code])
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
}

const closeDaySerial = async (commandFunction, deviceParams, sendMessageToWebView) => {
  let command = commandFunction()
  let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: command?.code || '', params: deviceParams?.printer || {} } })
  return res?.data || okeResponse(false, 400, 'Unknown error.', null)
}

const closeDayBT = async (commandFunction, deviceParams, sendMessageToWebView) => {
  let command = commandFunction()
  let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: command?.code || '', params: deviceParams?.printer || {} } })
  return res?.data || okeResponse(false, 400, 'Unknown error.', null)
}

const closeDayQR = async (commandFunction, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction()
  if (comRes?.code) {
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, null, [comRes.code])
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.receipt.commands.error" })
  }
}

// Storno new!
const printStornoReceiptSerial = async (fiscalReceipt, commandFunction, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt)
  if (comRes?.code == null) {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.stornoreceipt.commands.error" })
  }
  let res = await sendMessageToWebView({ action: 'oneWaySerialCommand', data: { cmd: comRes?.code || '', params: deviceParams?.printer || {} } })
  if (res?.data?.success) {
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.stornoreceipt.commands.error" })
  }
}

const printStornoReceiptBT = async (fiscalReceipt, commandFunction, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt)
  if (comRes?.code == null) {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.stornoreceipt.commands.error" })
  }
  let res = await sendMessageToWebView({ action: 'oneWayBTCommand', data: { cmd: comRes?.code || '', params: deviceParams?.printer || {} } })
  if (res?.data?.success) {
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, null)
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.stornoreceipt.commands.error" })
  }
}

const printStornoReceiptQR = async (fiscalReceipt, commandFunction, deviceParams, sendMessageToWebView) => {
  let comRes = commandFunction(fiscalReceipt, deviceParams?.printer?.vat)
  if (comRes?.code) {
    return receiptResult(true, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, null, [comRes.code])
  } else {
    return receiptResult(false, deviceParams?.printer?.type, deviceParams?.printer?.type, false, 0, null, { errorMsgCode: "print.stornoreceipt.commands.error" })
  }
}

export {
  printReceiptBT,
  printReceiptSerial,
  printReceiptQR,
  payInSerial,
  payInBT,
  payInQR,
  payOutSerial,
  payOutBT,
  payOutQR,
  openDaySerial,
  openDayBT,
  openDayQR,
  closeDaySerial,
  closeDayBT,
  closeDayQR,
  printStornoReceiptSerial,
  printStornoReceiptBT,
  printStornoReceiptQR
}